import { render, staticRenderFns } from "./LogoImage.vue?vue&type=template&id=6798795a&"
import script from "./LogoImage.vue?vue&type=script&lang=js&"
export * from "./LogoImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports